export default "__VITE_ASSET__CVFnpQRd__"